import { CoverThicknessAggregate, ProjectSheetItemsOrder, ProjectSheetToleranceType, } from '../interfaces/project';
export const DefaultSettings = Object.freeze({
    default_construction_properties: {
        construction_project_name: '',
        construction_type: '',
        construction_type_detailed: '',
    },
    sheet_models_visibility: {
        volume: true,
        plane: true,
        length_with_distance_tool: true,
        polyline: true,
    },
    sheet_rows_visibility: {
        polygon_length_1: true,
        polygon_length_2: true,
        edge_length: false,
        edge_length_with_value: false,
        polygon_perimeter: true,
        polygon_area: true,
        grid: true,
        volume: true,
        polyline_length: true,
        min_grid_depth: false,
        max_grid_depth: false,
        length_with_distance_tool: true,
        upper_plane_to_cylinders_distance: true,
        lower_plane_to_cylinders_distance: true,
    },
    sheet_rows_tolerance_type: {
        polygon_length_1: ProjectSheetToleranceType.AsymmetricTolerance,
        polygon_length_2: ProjectSheetToleranceType.AsymmetricTolerance,
        edge_length: ProjectSheetToleranceType.AsymmetricTolerance,
        edge_length_with_value: ProjectSheetToleranceType.AsymmetricTolerance,
        polygon_perimeter: ProjectSheetToleranceType.AsymmetricTolerance,
        polygon_area: ProjectSheetToleranceType.AsymmetricTolerance,
        grid: ProjectSheetToleranceType.AsymmetricTolerance,
        volume: ProjectSheetToleranceType.AsymmetricTolerance,
        polyline_length: ProjectSheetToleranceType.AsymmetricTolerance,
        min_grid_depth: ProjectSheetToleranceType.AsymmetricTolerance,
        max_grid_depth: ProjectSheetToleranceType.AsymmetricTolerance,
        length_with_distance_tool: ProjectSheetToleranceType.AsymmetricTolerance,
        upper_plane_to_cylinders_distance: ProjectSheetToleranceType.AsymmetricTolerance,
        lower_plane_to_cylinders_distance: ProjectSheetToleranceType.AsymmetricTolerance,
    },
    sheet_cols_visibility: {
        estimated_value: true,
        designed_value: true,
        tolerance: true,
    },
    sheet_diagram_visibility: {
        plane_diagram: true,
        grid_diagram: true,
        polyline_diagram: true,
    },
    sheet_use_inspection_group_order: true,
    sheet_order_type_of_items: ProjectSheetItemsOrder.CustomOrder,
    cover_thickness_value_type: {
        upper: CoverThicknessAggregate.Min,
        lower: CoverThicknessAggregate.Min,
    },
});
